<template>
  <router-link tag="div" :to="`work${project.path}`" class="preview">
    <div class="preview__image" @mouseenter="activeArrow = true" @mouseleave="activeArrow = false">
      <hover-show :images="[`/static/images/overview${project.path}.jpg`]" :title="project.title"></hover-show>
    </div>
    <div class="preview__info">
      <h2 class="preview__title"  @mouseenter="activeArrow = true" @mouseleave="activeArrow = false">
        {{ project.title }}<br><span class="c-light-grey">{{ project.year }}</span>
      </h2>
    </div>
  </router-link>
</template>

<script>
import HoverShow from '../HoverShow.vue'
import Arrow from '../Arrow.vue'

export default {
  name: 'project-preview',
  props: ['project'],
  data () {
    return {
      activeArrow: false
    }
  },
  components: {
    HoverShow,
    Arrow
  }
}
</script>

<style lang="sass" scoped>

@import "../../assets/sass/utilities/variables"
@import "../../assets/sass/utilities/mixins"

$preview-width: 48%
$preview-height: 45vw
$preview-gap: 4%
$preview-inner-gap: $preview-gap / 2


$preview-gap--medium: 2%
$preview-inner-gap--medium: $preview-gap--medium / 2

$preview-width--medium: (100% - 2 * $preview-gap--medium) / 3
$preview-height--medium: 30vw

.preview
  width: 90vw
  height: 90vw
  max-height: 416px
  margin-left: auto
  margin-right: auto
  margin-bottom: 75px
  +medium(max)
    &:nth-child(odd)
      margin-left: 0
    &:nth-child(even)
      margin-right: 0
  +small
    margin-left: $preview-inner-gap
    margin-right: $preview-inner-gap
    margin-bottom: calc(#{$preview-gap} + 3em)
    width: $preview-width
    height: $preview-height
  +medium
    margin-left: $preview-inner-gap--medium
    margin-right: $preview-inner-gap--medium
    margin-bottom: calc(#{$preview-gap--medium} + 3em)
    width: $preview-width--medium
    height: $preview-height--medium
    &:nth-child(3n - 2)
      margin-left: 0
    &:nth-child(3n)
      margin-right: 0
    &:nth-child(5)
      margin-right: $preview-width--medium
    &:nth-child(6)
      margin-right: 0
      margin-left: calc(#{$preview-width--medium} + #{$preview-gap--medium})
  +large
    &:nth-child(5)
      margin-right: $preview-width--medium
    &:nth-child(6)
      margin-left: auto
      margin-right: auto

.preview__image
  width: 100%
  height: 100%
  background-color: #AAA
  cursor: pointer

.preview__info
  display: flex
  justify-content: space-between
  flex-direction: column
  margin-top: 0.5rem

.preview__title
  font-size: 1rem
  margin: 0
  font-weight: 500
  cursor: pointer

</style>



// WEBPACK FOOTER //
// Preview.vue?5634af40